import { useEffect, useState } from 'react';
import { contactInfo } from '@/mocks/homeData';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    fbq: (action: string, eventName: string, params?: Record<string, unknown>) => void;
  }
}

export default function WppConfirmadoPage() {
  const [countdown, setCountdown] = useState(3);
  const [hasFired, setHasFired] = useState(false);

  const whatsappUrl = `https://wa.me/${contactInfo.whatsapp}?text=Olá!%20Vim%20pelo%20site%20da%20Dra.%20Marihana%20e%20gostaria%20de%20agendar%20uma%20avaliação.`;

  // Dispara eventos de conversão uma única vez ao carregar
  useEffect(() => {
    if (hasFired) return;
    setHasFired(true);

    // --- GTM: evento de conversão WhatsApp ---
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'whatsapp_conversion',
        conversionType: 'contact',
        source: 'google_ads',
        pageLocation: '/wpp-confirmado',
      });
    } catch { /* GTM não carregado */ }

    // --- Meta Pixel: evento Contact ---
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Contact', {
          content_name: 'WhatsApp Conversion',
          content_category: 'Conversão',
          source: 'google_ads',
        });
      }
    } catch { /* Pixel não carregado */ }
  }, [hasFired]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (countdown <= 0) {
      window.location.href = whatsappUrl;
      return;
    }

    const timer = setTimeout(() => {
      setCountdown((c) => c - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, whatsappUrl]);

  return (
    <main className="min-h-screen bg-background-50 flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 md:px-6 py-16">
        <div className="max-w-md w-full text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#25D366]/10 flex items-center justify-center">
            <i className="ri-whatsapp-line text-[#25D366] text-3xl"></i>
          </div>

          <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3 leading-tight">
            Redirecionando para o WhatsApp...
          </h1>
          <p className="text-foreground-500 text-sm leading-relaxed mb-6">
            Você será conectado com a Dra. Marihana Pasquali em <strong className="text-foreground-950">{countdown} segundo{countdown !== 1 ? 's' : ''}</strong>.
          </p>

          <div className="w-10 h-10 mx-auto mb-8">
            <svg className="animate-spin w-full h-full text-primary-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>

          <a
            href={whatsappUrl}
            className="whitespace-nowrap inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ea952] text-white text-sm font-semibold px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Clique aqui se não for redirecionado
          </a>

          <p className="text-xs text-foreground-400 mt-6">
            Dra. Marihana Pasquali — CRO-SP 172094 | Faria Lima, São Paulo
          </p>
        </div>
      </div>
    </main>
  );
}